import React from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import SvgIcon from '@mui/material/SvgIcon'
import CircularProgress from '@mui/material/CircularProgress'
import { CancelOutlined } from '@mui/icons-material'
import { ReactComponent as FolderSimplePlusIcon } from '../../../assets/images/FolderSimplePlus.svg'
import { useLayoutConstants } from '../hooks/useLayoutConstants'

interface TppComparisonColumnProps {
    title: string
    onClose?: () => void
    isLoading?: boolean
    showContext?: boolean
}

const TppComparisonColumn: React.FC<TppComparisonColumnProps> = ({ title, onClose, isLoading, showContext }) => {
    const layout = useLayoutConstants()
    const leftOffset = layout.SCROLL_START + (showContext ? layout.COLUMN_WIDTH : 0)
    const stickyStyle: React.CSSProperties = {
        position: 'sticky',
        left: leftOffset,
        zIndex: 45,
        backgroundColor: '#f5f5f5',
        borderRight: '2px solid',
        borderColor: '#3366FF',
        boxShadow: '4px 0 8px -4px rgba(0,0,0,0.1)',
    }

    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
                flex: '0 0 auto',
                width: layout.COLUMN_WIDTH,
                padding: '12px 16px',
                ...stickyStyle,
            }}
        >
            <Stack direction="row" alignItems="center" gap={1}>
                <SvgIcon
                    component={FolderSimplePlusIcon}
                    inheritViewBox
                    sx={{ fontSize: '18px', color: 'figma.grayscale.textHier2' }}
                />
                <Typography variant="18x600" color="figma.grayscale.tier2" noWrap>
                    {isLoading ? 'Loading...' : title}
                </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" gap={0.5}>
                {isLoading && <CircularProgress size={18} />}
                {onClose && (
                    <IconButton
                        onClick={onClose}
                        size="small"
                        sx={{
                            p: 0.5,
                        }}
                    >
                        <CancelOutlined sx={{ fontSize: '18px', color: 'figma.primary' }} />
                    </IconButton>
                )}
            </Stack>
        </Stack>
    )
}

export default TppComparisonColumn
